import React, { useState } from 'react';
import { Box, Button, Grid, TextField } from '@mui/material';
import { LactateClient } from '../types';
import {
  ManualClientValues,
  emptyManualClient,
  validateManualClient,
  toLactateClient,
} from '../utils/manualClient';

interface Props {
  onSubmit: (client: LactateClient) => void;
}

const FIELDS: { key: keyof ManualClientValues; label: string; type?: string }[] = [
  { key: 'mindbody_id', label: 'Mindbody client ID' },
  { key: 'email', label: 'Email', type: 'email' },
  { key: 'first_name', label: 'First name' },
  { key: 'surname', label: 'Surname' },
];

export const ManualClientForm: React.FC<Props> = ({ onSubmit }) => {
  const [values, setValues] = useState<ManualClientValues>(emptyManualClient());
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleChange =
    (key: keyof ManualClientValues) => (e: React.ChangeEvent<HTMLInputElement>) =>
      setValues((v) => ({ ...v, [key]: e.target.value }));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const validationErrors = validateManualClient(values);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;
    onSubmit(toLactateClient(values));
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <Grid container spacing={2}>
        {FIELDS.map((f) => (
          <Grid item xs={12} sm={6} key={f.key}>
            <TextField
              name={f.key}
              label={f.label}
              type={f.type ?? 'text'}
              value={values[f.key]}
              onChange={handleChange(f.key)}
              error={Boolean(errors[f.key])}
              helperText={errors[f.key]}
              fullWidth
              size="small"
              required
            />
          </Grid>
        ))}
      </Grid>
      <Button type="submit" variant="contained" sx={{ mt: 3 }}>
        Continue to test
      </Button>
    </Box>
  );
};
